require('./Queryextends');

require('./Prototype');






// WEBPACK FOOTER //
// ./src/others/index.js